<template>
    <!-- snb -->
    <nav id="snb">
        <section
            class="snb_sec faq_inquiry"
            v-if="isPageView(['viewFAQ', 'viewFAQNew', 'newQuestionList', 'newQuestionConnect'])"
        >
            <h2>{{ $t('FIELD.GLOBAL.INQUIRY.TYPE') }}</h2>
            <div class="list">
                <ul class="list_inquiry">
                    <li
                        :class="getSnbClass(item.INQUIRY_TYPE1)"
                        v-for="item in supportSnb.faqInquiry"
                        :key="pageName + item.INQUIRY_TYPE1 + item.INQUIRY_TYPE_NM1"
                    >
                        <a href="javascript:" @click="snbClick($event, item.INQUIRY_TYPE1, '', '')">
                            {{ item.INQUIRY_TYPE_NM1 }}
                            <em v-if="item.TOTAL_CNT && isPageView(['viewFAQ', 'viewFAQNew'])">
                                ({{ item.TOTAL_CNT }})
                            </em>
                        </a>
                        <a
                            href="javascript:"
                            class="ico_arrow"
                            @click="snbClick($event, item.INQUIRY_TYPE1, '', 'arrow')"
                            v-if="!('ALL' === item.INQUIRY_TYPE1 || 'ETC' === item.INQUIRY_TYPE1)"
                        >
                            <span class="sr_only"></span>
                        </a>
                        <ul v-if="!('ALL' === item.INQUIRY_TYPE1 || 'ETC' === item.INQUIRY_TYPE1)">
                            <li
                                v-for="itemSub in item.faqSubInquiry"
                                :key="pageName + item.INQUIRY_TYPE1 + itemSub.INQUIRY_TYPE2"
                                @click="snbClick($event, item.INQUIRY_TYPE1, itemSub.INQUIRY_TYPE2, '')"
                            >
                                <a href="javascript:">
                                    {{ itemSub.INQUIRY_TYPE_NM2 }}
                                    <em v-if="itemSub.TOTAL_CNT && isPageView(['viewFAQ', 'viewFAQNew'])">
                                        ({{ itemSub.TOTAL_CNT }})
                                    </em>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </section>

        <section class="snb_sec myctg_wrap" v-if="isPageView(['createNewFAQ', 'createNewQuestion'])">
            <h2>
                {{ $t('FIELD.FAQ.INQUIRY.QUICK') }}
                <a href="javascript:" class="ico_config" title="config"><span class="sr_only">config</span></a>
            </h2>
            <div class="list">
                <ul class="list_quick_inquiry">
                    <li
                        v-for="item in supportSnb.faqQuickInquiryList"
                        :key="pageName + item.WORK_KEY_1 + item.WORK_KEY_2 + item.WORK_KEY_3 + item.ROW_NUM"
                    >
                        <a
                            href="javascript:"
                            @click="getQuickInquiryClick(item.WORK_KEY_1, item.WORK_KEY_2, item.WORK_KEY_3)"
                        >
                            {{ getQuickName(item.WORK_KEY_1_NM, item.WORK_KEY_2_NM, item.WORK_KEY_3_NM) }}
                        </a>
                    </li>
                </ul>
            </div>
        </section>

        <section
            class="snb_sec myctg_wrap"
            v-if="
                isPageView([
                    'viewFAQ',
                    'viewFAQNew',
                    'createNewFAQ',
                    'newQuestionList',
                    'newQuestionConnect',
                    'createNewQuestion',
                ])
            "
        >
            <h2>
                {{ $t('TITLE.GLOBAL.QUICKCATEGORY') }}
                <a href="javascript:" class="ico_config" :title="$t('BUTTON.GLOBAL.CONFIG')" @click="btnCatConfig">
                    <span class="sr_only">{{ $t('BUTTON.GLOBAL.CONFIG') }}</span>
                </a>
            </h2>
            <div class="list">
                <ul class="list_myctg">
                    <li
                        v-for="item in supportSnb.faqQuickCategoryList"
                        :key="pageName + item.WORK_KEY_1 + item.WORK_KEY_2 + item.ROW_NUM"
                    >
                        <a href="javascript:" @click="getQuickCategoryClick(item.WORK_KEY_1, item.WORK_KEY_2)">
                            {{ getQuickName(item.WORK_KEY_1_NM, item.WORK_KEY_2_NM) }}
                        </a>
                    </li>
                </ul>
            </div>
        </section>
        <dl class="tree_wrap" v-if="isPageView(['questionList', 'answerList', 'answerListNew'])">
            <!-- <dt>no title</dt> -->
            <dd>
                <article class="tree_group">
                    <p class="tree_subtitle">{{ $t('FIELD.GLOBAL.INQUIRY.TYPE') }}</p>
                    <ul class="tree_list">
                        <label class="checkbox-wrap">
                            <input
                                type="checkbox"
                                name="all"
                                value="all"
                                class="inquiry0"
                                @change="treeChange($event, 'All', 'inquiry')"
                                checked
                            />
                            <i class="check-icon"></i>
                            <em>All</em>
                        </label>
                        <li v-for="item in inquiryCodeList" :key="pageName + item.CD">
                            <a
                                href="javascript:"
                                :class="'ETC' === item.CD ? '' : 'ico_tree'"
                                @click="treeClick($event, item.subCodeList)"
                            >
                                <span class="sr_only"></span>
                            </a>
                            <label class="checkbox-wrap">
                                <input
                                    type="checkbox"
                                    :name="item.CD + '_all'"
                                    :value="item.CD"
                                    class="inquiry1"
                                    @change="treeChange($event, item.CD)"
                                    checked
                                />
                                <i class="check-icon"></i>
                                <em>{{ item.CD_NAME }}</em>
                            </label>
                            <ul class="tree_sub_list" :key="pageName + item.CD + inquiryCount">
                                <li v-for="subCode in item.subCodeList" :key="pageName + item.CD + subCode.CD">
                                    <label class="checkbox-wrap">
                                        <input
                                            type="checkbox"
                                            :name="item.CD"
                                            :value="subCode.CD"
                                            class="inquiry2"
                                            @change="treeChange($event, item.CD, subCode.CD)"
                                            checked
                                        />
                                        <i class="check-icon"></i>
                                        <em>{{ subCode.CD_NAME }}</em>
                                    </label>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </article>

                <article class="tree_group">
                    <p class="tree_subtitle">{{ $t('FIELD.GLOBAL.CATEGORY') }}</p>
                    <ul class="tree_list">
                        <label class="checkbox-wrap">
                            <input
                                type="checkbox"
                                name="all"
                                value="all"
                                class="category0"
                                @change="treeChange($event, 'All', 'category')"
                                checked
                            />
                            <i class="check-icon"></i>
                            <em>All</em>
                        </label>
                        <li v-for="item in categoryCodeList" :key="pageName + item.code">
                            <a href="javascript:" class="ico_tree" @click="treeClick($event, item.subCodeList)">
                                <span class="sr_only"></span>
                            </a>
                            <label class="checkbox-wrap">
                                <input
                                    type="checkbox"
                                    :name="item.code + '_all'"
                                    :value="item.code"
                                    class="category1"
                                    @change="treeChange($event, item.code)"
                                    checked
                                />
                                <i class="check-icon"></i>
                                <em>{{ item.codeName }}</em>
                            </label>
                            <ul class="tree_sub_list" :key="pageName + item.code + inquiryCount">
                                <li v-for="subCode in item.subCodeList" :key="pageName + item.code + subCode.code">
                                    <label class="checkbox-wrap">
                                        <input
                                            type="checkbox"
                                            :name="item.code"
                                            :value="subCode.code"
                                            class="category2"
                                            @change="treeChange($event, item.code, subCode.code)"
                                            checked
                                        />
                                        <i class="check-icon"></i>
                                        <em>{{ subCode.codeName }}</em>
                                    </label>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </article>
            </dd>
            <dd class="btn">
                <a href="javascript:" class="btn_apply" @click="applyClick()">{{ $t('BUTTON.GLOBAL.APPLY') }}</a>
            </dd>
        </dl>

        <ul class="status_wrap" v-if="isPageView(['questionDetail', 'answerDetail'])">
            <li
                :class="getFlowClass(item.QNA_STATUS, item.FLOW_STATUS)"
                v-for="item in flowList"
                :key="pageName + item.QUESTION_FLOW_ID"
                @click="openUserDetail(getQuestionId, item.FLOW_STATUS, item.USER_NO, item.QUESTION_FLOW_ID, 'user')"
            >
                <p class="item_status" v-if="isNull(item.MESSAGE) && 0 === item.COMMENT_CNT">
                    {{ item.QNA_STATUS_NM }}
                </p>
                <p class="item_status" v-else>
                    <em
                        @click="
                            openUserDetail(
                                getQuestionId,
                                item.FLOW_STATUS,
                                item.USER_NO,
                                item.QUESTION_FLOW_ID,
                                'comment',
                                $event.stopPropagation(),
                            )
                        "
                    >
                        {{ item.QNA_STATUS_NM }}
                    </em>
                </p>
                <p class="item_name">{{ item.ANSWERER_NM }}</p>
                <p class="item_group">{{ item.ANSWERER_DEPT_NM }}</p>
                <p class="item_date">{{ item.REG_DT }}</p>
            </li>
        </ul>
        <section
            class="bn_wrap"
            v-if="isPageView(['questionDetail', 'answerDetail', 'returnSystem', 'newQuestionConnect'])"
        >
            <ul class="list_banner">
                <li class="bn_box">
                    <a href="javascript:" class="ico_knowledge" @click="btnSupport()">
                        {{ $t('FIELD.GLOBAL.KNOWLEDGE') }}
                    </a>
                </li>
            </ul>
        </section>
    </nav>
    <!-- //snb -->
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import { EventBus } from '@/utils/EventBus';
import { SDLUtil, MenuUtil } from '@/utils';
import { mapActions, mapGetters } from 'vuex';

import CategoryConfigPopup from '~vb/common/CategoryConfigPopup';

export default {
    name: 'faqSnb',
    data() {
        return {
            inquiryCount: 0,
            pageTitle: '',
            pageName: 'faqSnb',
            inquiryCodeList: [],
            categoryCodeList: [],
            flowList: [],
        };
    },
    computed: {
        ...mapGetters({
            loginSystem: 'getLoginSystem',
            supportSnb: 'getSupportSnb',
            supportSnbParams: 'getSupportSnbParams',
            deptLevelCd: 'getDeptLevelCd',
            deptNo: 'getDeptNo',
            menus: 'getMenus',
            loginRhq: 'getLoginRhq',
            userCorpCd: 'getCorpCd',
            returnSystem: 'getReturnSystem',
        }),
        getQuestionId() {
            let questionId = (this.$route.query.questionId || '').trim();
            return questionId;
        },
    },
    mounted() {
        EventBus.$on('question-snb-status', param => {
            if (
                this.isPageView([
                    'viewFAQ',
                    'viewFAQNew',
                    'createNewFAQ',
                    'newQuestionList',
                    'newQuestionConnect',
                    'createNewQuestion',
                ])
            ) {
                this.searchSnb();
            } else if (this.isPageView(['questionDetail', 'answerDetail'])) {
                this.searchFlowList(this.getQuestionId);
            }
        });

        if (
            this.isPageView([
                'viewFAQ',
                'viewFAQNew',
                'createNewFAQ',
                'newQuestionList',
                'newQuestionConnect',
                'createNewQuestion',
            ])
        ) {
            this.searchSnb();
        } else if (this.isPageView(['questionList', 'answerList', 'answerListNew'])) {
            this.inquiryList(1);
            this.categoryList(1);
            /*
            setTimeout(() => {
                this.applyClick();
            }, 500);
            */
        } else if (this.isPageView(['questionDetail', 'answerDetail'])) {
            this.searchFlowList(this.getQuestionId);
        }
    },
    methods: {
        ...mapActions(['setSupportSnb', 'setSupportSnbParams', 'changeSubsidiary']),

        initializeSnb(faqInquiry, faqQuickInquiryList, faqQuickCategoryList) {
            let saveSupportSnb = new Object();
            saveSupportSnb.faqInquiry = faqInquiry;
            saveSupportSnb.faqQuickInquiryList = faqQuickInquiryList;
            saveSupportSnb.faqQuickCategoryList = faqQuickCategoryList;
            this.setSupportSnb(saveSupportSnb);
        },
        initializeSnbParams(faqInquiry1Code, faqInquiry2Code, faqCategory1Code, faqCategory2Code, type) {
            let saveSupportSnb = new Object();
            saveSupportSnb.faqInquiry1Code = SDLUtil.nvl(faqInquiry1Code);
            saveSupportSnb.faqInquiry2Code = SDLUtil.nvl(faqInquiry2Code);
            saveSupportSnb.faqCategory1Code = SDLUtil.nvl(faqCategory1Code);
            saveSupportSnb.faqCategory2Code = SDLUtil.nvl(faqCategory2Code);
            saveSupportSnb.faqType = SDLUtil.nvl(type);
            this.setSupportSnbParams(saveSupportSnb);
        },
        pageMove(v) {
            if ('createNewFAQ' === v) {
                this.$router.push(MenuUtil.getSupportMain());
            }
        },
        async searchSnb() {
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/faq/faqSnb.skp`,
                    qs.stringify({
                        systemId: this.loginSystem,
                    }),
                )
                .then(resp => {
                    let getSubSnb = resp.data.search.getSubSnb;

                    for (const getSnb of resp.data.search.getSnb) {
                        getSnb.faqSubInquiry = [];
                        let cnt = getSubSnb.length;
                        for (let index = cnt; index > 0; index--) {
                            if (getSnb.INQUIRY_TYPE1 === getSubSnb[index - 1].INQUIRY_TYPE1) {
                                getSnb.faqSubInquiry.unshift(getSubSnb[index - 1]);
                                getSubSnb.splice[index - 1];
                            }
                        }
                    }

                    this.initializeSnb(
                        resp.data.search.getSnb,
                        resp.data.search.getQuickInquiry,
                        resp.data.search.getQuickCategory,
                    );
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        inquiryList(v, recursion) {
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/common/inquiryItem/inquiryItemList.skp`,
                    qs.stringify({
                        type: 'inquiryType' + v,
                        useyn: 'Y',
                        deptLevelCd: this.deptLevelCd,
                        deptNo: this.deptNo,
                        value: SDLUtil.nvl(recursion),
                    }),
                )
                .then(resp => {
                    if (v === 1) {
                        this.inquiryCodeList = resp.data.result.rowData;
                        for (const inquiry of this.inquiryCodeList) {
                            this.inquiryList(2, inquiry.CD);
                        }
                        this.inquiryCodeList.push({
                            REG_DT: '',
                            CD: 'ETC',
                            CD_NAME: 'ETC',
                            LEVEL_CD: 1,
                            REG_USER_NO: 'skp',
                            MODF_DT: '',
                            P_CD: '0',
                            SORT_ORD: 13,
                            MODF_USER_NO: 'skp',
                            STATUS_CD: 'A',
                        });
                    } else if (v === 2) {
                        var rowData = (resp.data.result && resp.data.result.rowData) || [];
                        if (rowData.length === 0) return;
                        for (const inquiry of this.inquiryCodeList) {
                            if (inquiry.CD === rowData[0].P_CD) {
                                inquiry.subCodeList = rowData;
                                inquiry.subCodeList.push({
                                    REG_DT: '',
                                    CD: 'Others',
                                    CD_NAME: 'Others',
                                    LEVEL_CD: 1,
                                    REG_USER_NO: 'skp',
                                    MODF_DT: '',
                                    P_CD: '0',
                                    SORT_ORD: 13,
                                    MODF_USER_NO: 'skp',
                                    STATUS_CD: 'A',
                                });
                                this.inquiryCount += 1;
                                return;
                            }
                        }
                    }
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        categoryList(v, recursion) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'ADM_CATEGORY_A';
                parentCode = '0';
                this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.categoryCodeList = resp;
                    for (const category of this.categoryCodeList) {
                        this.categoryList(2, category.code);
                    }
                });
            } else if (v === 2) {
                codeCategoryId = 'ADM_CATEGORY_B';
                parentCode = recursion;
                this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    for (const category of this.categoryCodeList) {
                        if (category.code === resp[0].parentCode) {
                            category.subCodeList = resp;
                            this.inquiryCount += 1;
                            return;
                        }
                    }
                });
            }
        },
        searchFlowList(v) {
            return axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionDetailFlowInfo.skp`,
                    qs.stringify({
                        questionId: v,
                    }),
                )
                .then(resp => {
                    this.flowList = resp.data.result.rowData;
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        getSnbClass(v) {
            let result = 'dir';
            let current = this.supportSnb.faqInquiry1Code;
            if (current === '') current = 'ALL';
            if (current === v) {
                result += ' active';
            }
            return result;
        },
        snbClick(e, strA, strB, strC) {
            if ('ALL' === strA) strA = '';

            if (SDLUtil.isNull(strB)) {
                $('.list_inquiry > li > a').removeClass('active');
                $('.list_inquiry > li .ico_arrow').removeClass('active');
                $(e.target).addClass('active');
            } else {
                $('.list_inquiry > li > ul > li > a').removeClass('active');
                $(e.target).addClass('active');
            }

            if ('arrow' === strC) return;

            this.initializeSnbParams(strA, strB, '', '', '');
        },
        getQuickInquiryClick(strA, strB) {
            $('.list_inquiry > li > a').removeClass('active');
            $('.list_inquiry > li .ico_arrow').removeClass('active');
            $('.list_inquiry > li > ul > li > a').removeClass('active');
            let strC = this.supportSnbParams.faqCategory1Code;
            let strD = this.supportSnbParams.faqCategory2Code;
            this.initializeSnbParams(strA, strB, strC, strD, 'I');
        },
        getQuickCategoryClick(strC, strD) {
            let strA = this.supportSnbParams.faqInquiry1Code;
            let strB = this.supportSnbParams.faqInquiry2Code;
            this.initializeSnbParams(strA, strB, strC, strD, 'C');
        },
        getQuickName(strA, strB, strC) {
            let result = '';
            let ConnectionText = ' > ';
            if (!SDLUtil.isNull(strA)) {
                result += strA;
                if (!SDLUtil.isNull(strB)) {
                    result += ConnectionText + strB;
                    if (!SDLUtil.isNull(strC)) {
                        result += ConnectionText + strC;
                    }
                }
            }
            return result;
        },
        isPageView(v) {
            let result = false;
            if (v.includes('returnSystem')) {
                if (!v.includes(this.$route.name) && ['WLDPTM', 'GSPN'].includes(this.returnSystem)) {
                    result = true;
                } else {
                    result = false;
                }
            } else if (v.includes(this.$route.name)) {
                result = true;
            }

            return result;
        },
        treeClick(e) {
            if (
                $(e.target)
                    .closest('li')
                    .hasClass('active') == true
            ) {
                $(e.target)
                    .closest('li')
                    .removeClass('active');
            } else {
                $('.tree_list > li').removeClass('active');
                $(e.target)
                    .closest('li')
                    .addClass('active');
            }
        },
        treeChange(e, v1, v2) {
            if ('All' === v1) {
                let checkValue = $('input[class=' + v2 + '0]').is(':checked');
                $('input[class=' + v2 + '1]').each(function(idx) {
                    $(this).prop('checked', checkValue);
                });
                $('input[class=' + v2 + '2]').each(function(idx) {
                    $(this).prop('checked', checkValue);
                });
            } else if (SDLUtil.isNull(v2)) {
                if ('ETC' === v1) return;
                if ($(e.target).is(':checked')) {
                    $('input[name=' + v1 + ']').each(function(idx) {
                        $(this).prop('checked', true);
                    });
                } else {
                    $('input[name=' + v1 + ']').each(function(idx) {
                        $(this).prop('checked', false);
                    });
                }
            } else {
                var _$length = $('input[name=' + v1 + ']').length;
                if ($('input[name=' + v1 + ']:checked').length == _$length) {
                    $('input[name=' + v1 + '_all]').prop('checked', true);
                } else {
                    $('input[name=' + v1 + '_all]').prop('checked', false);
                }
            }
        },
        applyClick() {
            let inquiry1 = '';
            let inquiry2 = '';
            let inquiry3 = '';
            let category1 = '';
            let category2 = '';
            let inquiryETC = false;

            $('input[class=inquiry1]:checked').each(function(idx) {
                if (!SDLUtil.isNull(inquiry1)) inquiry1 += ',';
                inquiry1 += $(this).val();
                if ('ETC' === $(this).val()) {
                    inquiryETC = true;
                }
            });

            $('input[class=inquiry2]:checked').each(function(idx) {
                if (!$('input[name=' + $(this).prop('name') + '_all]').is(':checked')) {
                    if ('Others' === $(this).val()) {
                        if (!SDLUtil.isNull(inquiry3)) inquiry3 += ',';
                        inquiry3 += $(this).prop('name');
                    } else {
                        if (!SDLUtil.isNull(inquiry2)) inquiry2 += ',';
                        inquiry2 += $(this).val();
                    }
                }
            });

            $('input[class=category1]:checked').each(function(idx) {
                if (!SDLUtil.isNull(category1)) category1 += ',';
                category1 += $(this).val();
            });

            $('input[class=category2]:checked').each(function(idx) {
                if (!$('input[name=' + $(this).prop('name') + '_all]').is(':checked')) {
                    if (!SDLUtil.isNull(category2)) category2 += ',';
                    category2 += $(this).val();
                }
            });

            let qnaInquiry = { inquiry1: inquiry1, inquiry2: inquiry2, inquiry3: inquiry3, inquiryETC: inquiryETC };
            let qnaCategory = { category1: category1, category2: category2 };

            EventBus.$emit('question-answer-list', {
                qnaInquiry: { inquiry1: inquiry1, inquiry2: inquiry2, inquiry3: inquiry3, inquiryETC: inquiryETC },
                qnaCategory: { category1: category1, category2: category2 },
            });
        },
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.userCorpCd);
            return codeResp;
        },
        getFlowClass(qnaStatus, flowStatus) {
            let result = '';
            if ('REG' === flowStatus && 'REG' === qnaStatus) {
                result = 'question';
            } else if ('ANS' === flowStatus) {
                result = 'answer';
            } else if ('END' === qnaStatus) {
                result = 'answer';
            }
            return result;
        },
        openUserDetail(questionId, flowStatus, userNo, flowId, tab) {
            if ('user' === tab) {
                EventBus.$emit('question-detail-user-popup', {
                    questionId: questionId,
                    flowStatus: flowStatus,
                    userNo: userNo,
                    questionFlowId: flowId,
                });
            } else if ('comment' === tab) {
                if ('PRO' === flowStatus) {
                    EventBus.$emit('question-detail-user-popup-communication', {
                        questionId: questionId,
                        flowStatus: flowStatus,
                        userNo: userNo,
                        questionFlowId: flowId,
                    });
                } else {
                    EventBus.$emit('question-detail-user-popup-comment', {
                        questionId: questionId,
                        flowStatus: flowStatus,
                        userNo: userNo,
                        questionFlowId: flowId,
                    });
                }
            }
        },
        isNull(v) {
            return SDLUtil.isNull(v);
        },
        async btnSupport() {
            let reLoginData = { loginSystem: this.returnSystem };
            if (Number(this.deptLevelCd) === 1) {
                Object.assign(reLoginData, {
                    topRhqCd: this.loginRhq,
                    topSubsidiaryCd: this.userCorpCd,
                });
            } else {
                Object.assign(reLoginData, {
                    topRhqCd: $('#selectRhqCd :selected').val(),
                    topRhqNm: $('#selectRhqCd :selected').html(),
                    topSubsidiaryCd: $('#selectRhqSubCd :selected').val(),
                    topSubsidiaryNm: $('#selectRhqSubCd :selected').html(),
                });
            }

            SDLUtil.showLoadingBar(true);
            const loginResult = await this.changeSubsidiary(reLoginData).catch(err => {
                SDLUtil.showLoadingBar(false);
                SDLUtil.errorAlert(err);
            });

            this.afterLoginProcess(loginResult);
        },
        afterLoginProcess(loginResult) {
            if (loginResult) this.gotoMain();
            EventBus.$emit('router-reload');
            SDLUtil.showLoadingBar(false);
        },
        gotoMain() {
            window.scrollTo(0, 0);
            this.$router.push('/');
        },
        btnCatConfig() {
            SDLUtil.show(
                CategoryConfigPopup,
                {
                    rtnFunc: () => {
                        this.pageMove('createNewFAQ');
                    },
                },
                { height: 'auto' },
            );
        },
    },
    beforeDestroy() {
        EventBus.$off('question-snb-status');
    },
};
</script>

<style scoped>
.status_wrap > li.answer .item_name {
    color: #e0e0e0 !important;
    opacity: 1;
}
.status_wrap > li.answer .item_date {
    color: #b8b8b8 !important;
    opacity: 1;
}
.status_wrap > li.question .item_date {
    color: #efefef !important;
    opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/faq/common/faqSnb.vue